import { AuthProvider, SettingsProvider } from '@nest/common-core-frontend-react';
import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import App from './App';
import { environment } from './environment';
import './index.css';

if (environment.env !== 'development') {
	Sentry.init({
		dsn: 'https://2ec5891d34ab0eae01c83d99ad5d42fc@sentry.tirextyre.cz/3',
		integrations: [
			Sentry.browserTracingIntegration(),
			Sentry.replayIntegration({
				maskAllInputs: true,
				maskAllText: false,
				mask: ['.mask']
			})
		],
		tracesSampleRate: 1.0,
		replaysOnErrorSampleRate: 1.0,
		tracePropagationTargets: [environment.apiUrl],
		replaysSessionSampleRate: environment.env === 'test' || environment.env === 'production' ? 1 : 0.1,
		environment: environment.env
	});
}

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<SettingsProvider settings={environment}>
			<AuthProvider>
				<BrowserRouter>
					<App />
				</BrowserRouter>
			</AuthProvider>
		</SettingsProvider>
	</StrictMode>
);
